import { Config } from '@genial/config';
import { initializeApp } from 'firebase/app';
import { doc, getDoc, getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: Config.GenialFirebaseApiKey,
  authDomain: Config.GenialFirebaseAuthDomain,
  projectId: Config.GenialFirebaseProjectId,
  storageBucket: Config.GenialFirebaseStorageBucket,
  messagingSenderId: Config.GenialFirebaseMessagingSenderId,
  appId: Config.GenialFirebaseAppId,
  measurementId: Config.GenialFirebaseMeasurementId,
};

const app = initializeApp(firebaseConfig);

export const initFirebase = () => app;

export const getFirestoreDocumentValue = (key: string) => {
  const firestore = getFirestore(app);
  const docRef = doc(firestore, Config.GenialFirebaseEnv, key);

  return getDoc(docRef);
};
